import React from "react"
import { useFormContext } from "react-hook-form"
import ContentSection from "../../../../../../components/Habitacional/ContentSection"
import * as S from "./CompleteFormDFI.Style"
import { ReactComponent as Calendar } from "../../../../../../assets/images/habitacional/calendar-icon.svg"
import Button from "../../../../../../components/Habitacional/core/Button"

const CompleteFormDFI = ({ comunicatorId }) => {
    const { watch } = useFormContext()
    const SelectDataVisit = watch("SelectDataVisit");
    const PhoneNumber = watch("PhoneNumber");
    const Address = watch("Address");
    return (
        <S.ContainerCompleteFormDFI>
            <ContentSection illustration={<Calendar height="316px" />} title="Tudo certo!" noPadding>
                <S.ContainerTextCompleteFormDFI>
                    <S.DescriptionDataCompleteFormDFI>
                        Seu pedido de indenização foi recebido.
                        Agora, vamos entrar em contato para agendar a vistoria que será remota e, em seguida, faremos a análise do seu pedido.
                        <br />
                        <br />
                        Vale lembrar que a nossa chamada pode ter códigos de DDD diferentes, pois são feitas de diversos locais.
                        <br />
                        <br />
                        Guarde o número do pedido de indenização para acompanhar o andamento do processo.
                    </S.DescriptionDataCompleteFormDFI>
                </S.ContainerTextCompleteFormDFI>
            </ContentSection>

            <S.ContainerDataCompleteFormDFI>
                <S.ContentDataCompleteFormDFI>
                    <S.DataCompleteFormDFI>
                        <S.TitleDataCompleteFormDFI>
                            Período escolhido para a vistoria
                        </S.TitleDataCompleteFormDFI>
                        <S.DescriptionDataCompleteFormDFI>
                            {SelectDataVisit.value}
                        </S.DescriptionDataCompleteFormDFI>
                    </S.DataCompleteFormDFI>

                    <S.DataCompleteFormDFI>
                        <S.TitleDataCompleteFormDFI>
                            Telefone para contato
                        </S.TitleDataCompleteFormDFI>
                        <S.DescriptionDataCompleteFormDFI>
                            {PhoneNumber}
                        </S.DescriptionDataCompleteFormDFI>
                    </S.DataCompleteFormDFI>
                </S.ContentDataCompleteFormDFI>

                <S.ContentDataCompleteFormDFI>
                    <S.DataCompleteFormDFI>
                        <S.TitleDataCompleteFormDFI>
                            Endereço do imóvel
                        </S.TitleDataCompleteFormDFI>
                        <S.DescriptionDataCompleteFormDFI>
                            {Address}
                        </S.DescriptionDataCompleteFormDFI>
                    </S.DataCompleteFormDFI>
                </S.ContentDataCompleteFormDFI>
            </S.ContainerDataCompleteFormDFI>

            <S.ContentNumberCompleteFormDFI>
                <S.TitleNumberCompleteFormDFI>
                    Número do pedido
                </S.TitleNumberCompleteFormDFI>
                <S.NumberCompleteFormDFI>
                    {comunicatorId}
                </S.NumberCompleteFormDFI>
            </S.ContentNumberCompleteFormDFI>

            <Button variant="primary" type="button">Acompanhar pedido</Button>

        </S.ContainerCompleteFormDFI>
    )
}

export default CompleteFormDFI